import { getCurrentDateInJapan } from "~/utils/jstDate";

/**
 * 指定キーについて、当日（JST）まだ実行していなければ true を返す。
 * localStorage が使えない場合は false（＝実行しない側）に倒す。
 */
export const hasDoneTodayJst = (key: string): boolean => {
  try {
    return localStorage.getItem(key) === getCurrentDateInJapan();
  } catch {
    return false;
  }
};

/**
 * 指定キーについて、当日（JST）実行済みとして localStorage に記録する。
 */
export const markDoneTodayJst = (key: string): void => {
  try {
    localStorage.setItem(key, getCurrentDateInJapan());
  } catch {
    // プライベートブラウジング等で localStorage が使えない場合は無視する
  }
};
